// Shared contact form shape used by the Contacts workspace and the unified
// Search page's edit dialog.
export const contactDefaults = {
  name: "",
  phone_number: "",
  email: "",
  company: "",
  secondary_contact: "",
  secondary_phone: "",
  secondary_email: "",
  notes: "",
  callsMade: 0,
  followUpCalls: 0,
  emailsSent: 0,
  dropIns: 0,
  custom_fields: {},
};

export const fieldRows = [
  { name: "name", label: "Name" },
  { name: "phone_number", label: "Phone Number" },
  { name: "email", label: "Email" },
  { name: "company", label: "Company" },
  { name: "secondary_contact", label: "Secondary Contact" },
  { name: "secondary_phone", label: "Secondary Phone" },
  { name: "secondary_email", label: "Secondary Email" },
];

export const metricRows = [
  { name: "callsMade", label: "Calls Made" },
  { name: "followUpCalls", label: "Follow-Up Calls" },
  { name: "emailsSent", label: "Emails Sent" },
  { name: "dropIns", label: "Drop-Ins" },
];

export const normalizeContact = (contact) => ({
  ...contactDefaults,
  ...contact,
  callsMade: contact?.callsMade ?? 0,
  followUpCalls: contact?.followUpCalls ?? 0,
  emailsSent: contact?.emailsSent ?? 0,
  dropIns: contact?.dropIns ?? 0,
  custom_fields: contact?.custom_fields || {},
});
